import type { CSSProperties, MouseEvent, MouseEventHandler, ReactNode } from 'react';
import { cn } from '@savvy-kit/lib/utils';

type LinkComponentProps = {
  readonly href: string;
  readonly className?: string;
  readonly onClick?: MouseEventHandler;
  readonly style?: CSSProperties;
  readonly children?: ReactNode;
};

type CellLinkProps = {
  readonly href: string;
  readonly children: ReactNode;
  /**
   * Link component to render. Defaults to a native `<a>`. Pass a router-aware
   * component (e.g. Next's `Link`) when client-side navigation is required.
   */
  readonly linkComponent?: React.ComponentType<LinkComponentProps>;
  readonly className?: string;
  readonly onClick?: MouseEventHandler;
};

function DefaultLink({ href, className, onClick, style, children }: LinkComponentProps) {
  return (
    <a href={href} className={className} onClick={onClick} style={style}>
      {children}
    </a>
  );
}

export function CellLink({
  href,
  children,
  linkComponent: LinkComponent = DefaultLink,
  className,
  onClick,
}: CellLinkProps) {
  const handleClick = (event: MouseEvent) => {
    event.stopPropagation();
    onClick?.(event);
  };

  return (
    <LinkComponent
      href={href}
      className={cn('block h-full w-full px-4 py-3 text-foreground no-underline', className)}
      onClick={handleClick}
    >
      {children}
    </LinkComponent>
  );
}
